let accordions = document.querySelectorAll('.accordion__header')

accordions.forEach((item) => {
    item.addEventListener('click', () => {
        body = item.nextElementSibling;
        body.classList.toggle('accordion__body--open');
        item.querySelector('.accordion__icon div').classList.toggle('accordion__icon--active')
    });
})